import React from 'react'
import PropTypes from 'prop-types'
// import { DatePicker } from 'material-ui-pickers'
import { DatePicker } from '@material-ui/pickers'
import ChevronLeft from '@material-ui/icons/ChevronLeft'
import ChevronRight from '@material-ui/icons/ChevronRight'

const DatePickerComponent = ({
  value,
  onChange,
  maxDate,
  minDate,
  ...datePickerProps
}) => (
  <DatePicker
    autoOk
    value={value}
    disableFuture
    minDate={minDate}
    maxDate={maxDate}
    onChange={onChange}
    format="dd/MM/yyyy"
    leftArrowIcon={<ChevronLeft />}
    rightArrowIcon={<ChevronRight />}
    {...datePickerProps}
  />
)

DatePickerComponent.propTypes = {
  onChange: PropTypes.func,
  classes: PropTypes.object,
  value: PropTypes.instanceOf(Date),
  minDate: PropTypes.instanceOf(Date),
  maxDate: PropTypes.instanceOf(Date),
}

export default DatePickerComponent



// WEBPACK FOOTER //
// ./src/components/organisms/DatePicker.js